import { Component, Element, h, Host, Prop } from "@stencil/core";
import { StyledComponent } from "../../../decorators/styled-component";
// import { InitLogging } from "../../../decorators/init-logging";
// import pfx from "../../../utils/style-class-prefix-helper";

@Component({
  tag: "eon-ui-carousel-item",
  styleUrl: "carousel-item.scss",
  shadow: true
})
export class CarouselItem {
  // @InitLogging() sentryTransaction;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiCarouselItemElement;

  /**
   * Specifies the label to use for accessibility.
   */
  @Prop({ attribute: "a11y-aria-label", mutable: true }) a11yAriaLabel: string;

  componentWillLoad() {
    this.deprecatedFallback();
    this.moveTooltipsToEndOfBody();
  }

  private moveTooltipsToEndOfBody() {
    const toolTips = this.hostElement.querySelectorAll("eon-ui-tooltip");
    toolTips?.forEach((element) => {
      element.setAttribute("move-tooltip-to-end-of-body", "true");
    });
  }

  deprecatedFallback() {
    this.a11yAriaLabel = this.hostElement.getAttribute("aria-label") ?? this.a11yAriaLabel;
  }

  render() {
    return (
      <Host {...(this.a11yAriaLabel ? { "aria-label": this.a11yAriaLabel } : {})}>
        <slot />
      </Host>
    );
  }
}
